import {CompanyRoles} from 'Authority'
import RouteConstant from 'constants/RouteConstant'
import CommonLayout from 'layouts/Common'
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import RouteIf from 'routes/RouteIf'
import ProductsManagement from 'pages/ProductsPages/ProductsList/PageTable'
import ProductsDetail from 'pages/ProductsPages/ProductsDetail'
import useProductManagement from 'features/productManagement/useProductManagement'

export default function ProductsRoute() {
  const {getAllPackageList} = useProductManagement()

  useEffect(() => {
    getAllPackageList()
  }, [])

  return (
    <CommonLayout>
      <Switch>
        <RouteIf
          requiredRoles={CompanyRoles}
          path={RouteConstant.PRODUCTS_MGS_LIST.path}
          exact
          component={ProductsManagement}
        />

        <RouteIf
          requiredRoles={CompanyRoles}
          path={RouteConstant.PRODUCTS_MGS_DETAIL.path}
          exact
          component={ProductsDetail}
        />

        <RouteIf
          requiredRoles={CompanyRoles}
          path={RouteConstant.PRODUCTS_MGS_UPDATE.path}
          exact
          component={ProductsDetail}
        />

        <RouteIf
          requiredRoles={CompanyRoles}
          path={RouteConstant.PRODUCTS_MGS_CREATE.path}
          exact
          component={ProductsDetail}
        />

        <Route path='*'>
          <Redirect to={RouteConstant.ERROR_NOT_FOUND.path} />
        </Route>
      </Switch>
    </CommonLayout>
  )
}
